import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEventStore } from '../../store/event/eventStore';
import { useCountdown } from '../../hooks/countdown/countdown';
import { getDatePartsString } from '../../common/dateUtils';
import './NextEventCountdown.scss';
import reactStringReplace from 'react-string-replace';

interface NextEventCountdownProps {
  eventStartedCallback: () => void;
}

const getCountdownText = (t: (str: string) => string, countdownString: string) => {
  return reactStringReplace(t('first-race-starts-in'), '{{countdown}}', (match, index) => (
    <div key={index} className='event-countdown-text__time'>
      {countdownString}
    </div>
  ));
};

const NextEventCountdown = ({ eventStartedCallback }: NextEventCountdownProps) => {
  const { t } = useTranslation();
  const startTime = useEventStore((s) => s.summary?.minEventStartTime ?? 0);

  const countdown = useCountdown({ startTime, onComplete: eventStartedCallback });
  const countdownString = getDatePartsString(countdown, t);

  return (
    <div className='event-countdown'>
      <div className='event-countdown-text'>{getCountdownText(t, countdownString)}</div>
    </div>
  );
};
export default NextEventCountdown;
